import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import ApiService from '../../../services/ApiService';
import CustomUnderlineText from '../../../components/Elements/underlineText/underlineText';
import Modal from '../../../components/Elements/modal/modal';
import './variantSummary.css';




 
const ComplateData = (props) => {
    const apiService = ApiService.getInstance();
    let [modalClass, showModal] = useState("modal hidden")
    let [modalClassII, showModalII] = useState("modal hidden")
    let [modalClassIII, showModalIII] = useState("modal hidden")
    const [formData, setFormData] = useState({
        // firstName: '',
        // lastName: '',
        genderDVID: 0,
        dateOfBirdth: '',
        pesel: '',
        street: '',
        building: '',
        flat: '',
        city: '',
        postalCode: '',
        // email: '',
        // phone: '',
        // personalDataProcessingConsent: 0,
        // currentPurchaseKey: key,
     
    });
    const [formDataParcipent, setFormDataParcipent] = useState({
        // firstName: '',
        // lastName: '',
        genderDVID: 0,
        dateOfBirdth: '',
        pesel: '',
        street: '',
        building: '',
        flat: '',
        city: '',
        postalCode: '',
        // email: '',
        // phone: '',
        // personalDataProcessingConsent: 0,
        // currentPurchaseKey: key,
     
    });
    
    const [formDataValidation, setFormDataValidation] = useState({
        // firstName: true,
        // lastName: true,
        dateOfBirdth: true,
        pesel: true,
        street: true,
        building: true,
        genderDVID: true,
        city: true,
        postalCode: true,
        // email: true,
        // phone: true,
        // personalDataProcessingConsent: true,
        // statuteDataProcessingConsent: false,
    });
    const [formDataValidationParcipent, setFormDataValidationParcipent] = useState({
        // firstName: true,
        // lastName: true,
        dateOfBirdth: true,
        pesel: true,//
        street: true,//
        building: true,
        genderDVID: true,//
        city: true,//
        postalCode: true,//
        // email: true,
        // phone: true,
        // personalDataProcessingConsent: true,
        // statuteDataProcessingConsent: false,
    });
    const [formDataPayer, setFormDataPayer] = useState({
        // firstName: '',
        // lastName: '',
        genderDVID: 0,
        dateOfBirdth: '',
        pesel: '',
        street: '',
        building: '',
        flat: '',
        city: '',
        postalCode: '',
        // email: '',
        // phone: '',
        // personalDataProcessingConsent: 0,
        // currentPurchaseKey: key,
     
    });
    const [formDataValidationPayer, setFormDataValidationPayer] = useState({
        // firstName: true,
        // lastName: true,
        dateOfBirdth: true,
        pesel: true,//
        street: true,//
        building: true,
        genderDVID: true,//
        city: true,//
        postalCode: true,//
        // email: true,
        // phone: true,
        // personalDataProcessingConsent: true,
        // statuteDataProcessingConsent: false,
    });
    const [status, setStatus] = useState({
        tittle:"",
        msg:"",
        part:""})
    const userDataCheck = JSON.parse( localStorage.getItem('users'));
    const parcipientNameDataCheck = JSON.parse( localStorage.getItem('selectedPartipient'));
    let adultPersonForUser = JSON.parse(localStorage.getItem('selectedPayers'));
    function updateData(){
        let validUser = {}
        let dataUser = {}
      
        if(formData.genderDVID == 0 && props.userData.genderDVID == 0){
            validUser.genderDVID = false;
        }else if(formData.genderDVID == 0){
            dataUser.genderDVID = props.userData.genderDVID
        }
        if(formData.pesel == "" && props.userData.pesel == ""){
            validUser.pesel = false;
        }else if(formData.pesel == ""){
            dataUser.pesel = props.userData.pesel
        }
        if(formData.street == "" && props.userData.street == ""){
            validUser.street = false;
        }else if(formData.street == ""){
            dataUser.street = props.userData.street
        }
        if(formData.city == "" && props.userData.city == ""){
            validUser.city = false;
        }else if(formData.city == ""){
            dataUser.city = props.userData.city
        }
        if(formData.postalCode == "" && props.userData.postalCode == ""){
            validUser.postalCode = false;
        }else if(formData.postalCode == ""){
            dataUser.postalCode = props.userData.postalCode
        }
        if(formData.building == "" && props.userData.building == ""){
            validUser.building = false;
        }else if(formData.building == ""){
            dataUser.building = props.userData.building
        }
      
        if(formData.dateOfBirdth == "" && props.userData.dateOfBirdth == "01/01/0001 00:00:00"){
            validUser.dateOfBirdth = false;
        }
        else if(formData.dateOfBirdth == "" && props.userData.dateOfBirdth == null){
            validUser.dateOfBirdth = false;
        }
        else if(formData.dateOfBirdth == "01/01/0001 00:00:00"){
            dataUser.dateOfBirdth = props.userData.dateOfBirdth
        }
        if(props.parcipientData != null){
          
        }
       
        setFormDataValidation({...formDataValidation,...validUser})

        register()
    }
    function updateParcipentData(){
        let validParcipent = {}
        let dataParcipent = {}
        
        if(formDataParcipent.genderDVID == 0 && props.parcipientData.genderDVID == 0){
            validParcipent.genderDVID = false;
        }else if(formDataParcipent.genderDVID == 0){
            dataParcipent.genderDVID = props.parcipientData.genderDVID
        }
        if(formDataParcipent.pesel == "" && props.parcipientData.pesel == ""){
            validParcipent.pesel = false;
        }else if(formDataParcipent.pesel == ""){
            dataParcipent.pesel = props.parcipientData.pesel
        }
        if(formDataParcipent.street == "" && props.parcipientData.street == ""){
            validParcipent.street = false;
        }else if(formDataParcipent.street == ""){
            dataParcipent.street = props.parcipientData.street
        }
        if(formDataParcipent.city == "" && props.parcipientData.city == ""){
            validParcipent.city = false;
        }else if(formDataParcipent.city == ""){
            dataParcipent.city = props.parcipientData.city
        }
        if(formDataParcipent.postalCode == "" && props.parcipientData.postalCode == ""){
            validParcipent.postalCode = false;
        }else if(formDataParcipent.postalCode == ""){
            dataParcipent.postalCode = props.parcipientData.postalCode
        }
        if(formDataParcipent.building == "" && props.parcipientData.building == ""){
            validParcipent.building = false;
        }else if(formDataParcipent.building == ""){
            dataParcipent.building = props.parcipientData.building
        }
        if(formDataParcipent.dateOfBirdth == "01/01/0001 00:00:00" && props.parcipientData.dateOfBirdth == "01/01/0001 00:00:00"){
            validParcipent.dateOfBirdth = false;
        }else if(formDataParcipent.dateOfBirdth == "" && props.parcipientData.dateOfBirdth == null){
            validParcipent.dateOfBirdth = false;}            
        else if(formDataParcipent.dateOfBirdth == "01/01/0001 00:00:00"){
            dataParcipent.dateOfBirdth = props.parcipientData.dateOfBirdth
        }
     
        setFormDataValidationParcipent({...formDataValidationParcipent, ...validParcipent})
        registerParcipent()
    }
    function updatePayerData(){
        let validParcipent = {}
        let dataParcipent = {}
        
        if(formDataPayer.genderDVID == 0 && adultPersonForUser.genderDVID == 0){
            validParcipent.genderDVID = false;
        }else if(formDataPayer.genderDVID == 0){
            dataParcipent.genderDVID = adultPersonForUser.genderDVID
        }
        if(formDataPayer.pesel == "" && adultPersonForUser.pesel == ""){
            validParcipent.pesel = false;
        }else if(formDataPayer.pesel == ""){
            dataParcipent.pesel = adultPersonForUser.pesel
        }
        if(formDataPayer.street == "" && adultPersonForUser.street == ""){
            validParcipent.street = false;
        }else if(formDataPayer.street == ""){
            dataParcipent.street = adultPersonForUser.street
        }
        if(formDataPayer.city == "" && adultPersonForUser.city == ""){
            validParcipent.city = false;
        }else if(formDataPayer.city == ""){
            dataParcipent.city = adultPersonForUser.city
        }
        if(formDataPayer.postalCode == "" && adultPersonForUser.postalCode == ""){
            validParcipent.postalCode = false;
        }else if(formDataPayer.postalCode == ""){
            dataParcipent.postalCode = adultPersonForUser.postalCode
        }
        if(formDataPayer.building == "" && adultPersonForUser.building == ""){
            validParcipent.building = false;
        }else if(formDataPayer.building == ""){
            dataParcipent.building = adultPersonForUser.building
        }
        if(formDataPayer.dateOfBirdth == "01/01/0001 00:00:00" && adultPersonForUser.dateOfBirdth == "01/01/0001 00:00:00"){
            validParcipent.dateOfBirdth = false;
        }else if(formDataPayer.dateOfBirdth == "" && adultPersonForUser.dateOfBirdth == null){
            validParcipent.dateOfBirdth = false;}            
        else if(formDataPayer.dateOfBirdth == "01/01/0001 00:00:00"){
            dataParcipent.dateOfBirdth = adultPersonForUser.dateOfBirdth
        }

        setFormDataValidationPayer({...formDataValidationPayer, ...validParcipent})
        registerPayer()
    }
    function changeModal(){
        if(modalClass == "modal hidden"){
           showModal("modal")
        }else{
           showModal("modal hidden")
        }}
        function changeModalII(){
            if(modalClassII == "modal hidden"){
                showModalII("modal")
            }else{
                showModalII("modal hidden")
            }}
            function changeModalIII(){
                if(modalClassIII == "modal hidden"){
                    showModalIII("modal")
                }else{
                    showModalIII("modal hidden")
                }}    
    function register() {
        
        formData.UsersID = props.userData.usersID
         
            
        if (
          
            formData.dateOfBirdth != '' &&
            formDataValidation.pesel &&
            formData.street != '' &&
            formData.building != '' &&
            formData.genderDVID != 0 &&
            formData.city != '' &&
            formData.postalCode != '' 
      
        ) {
            

            apiService.apiPost(
                'UpdateUser',
                formData,
                (response) => {
                    if(response.success){
                
                        changeModal()
                   
                    }else{
                      
                       
                        setStatus({
                            tittle:"Nie udało się zaktualizować towich danych",
                            msg:"Spróbuj ponownie lub skontaktuj się z Biurem Obsługi Klienta.",
                            part:"3"})
                    }
                })}}

                function registerParcipent() {
                    formDataParcipent.UsersID = props.parcipientData.usersID
       
              
                    if (
                      
                        formDataParcipent.dateOfBirdth != '' &&
                        formDataValidationParcipent.pesel &&
                        formDataParcipent.street != '' &&
                        formDataParcipent.building != '' &&
                        formDataParcipent.genderDVID != 0 &&
                        formDataParcipent.city != '' &&
                        formDataParcipent.postalCode != '' 
                  
                    ) {
                        
            
                        apiService.apiPost(
                            'UpdateUser',
                            formDataParcipent,
                            (response) => {
                                if(response.success){
                                    changeModalII()
                                }else{
                                    setStatus({
                                        tittle:"Nie udało się zaktualizować danych Osoy Powiązanej",
                                        msg:"Spróbuj ponownie lub skontaktuj się z Biurem Obsługi Klienta.",
                                        part:"3"})
                                }
                            })}
                            else{
                                // modal sukces user porażka parcipient
                            }

                }
                function registerPayer() {
                    formDataPayer.UsersID = adultPersonForUser.usersID
         
                    if (
                      
                        formDataPayer.dateOfBirdth != '' &&
                        formDataValidationPayer.pesel &&
                        formDataPayer.street != '' &&
                        formDataPayer.building != '' &&
                        formDataPayer.genderDVID != 0 &&
                        formDataPayer.city != '' &&
                        formDataPayer.postalCode != '' 
                  
                    ) {
                        
            
                        apiService.apiPost(
                            'UpdateUser',
                            formDataPayer,
                            (response) => {
                             
                                if(response.success){
                                    changeModalIII()
                                }else{
                                    setStatus({
                                        tittle:"Nie udało się zaktualizować danych Osoy Powiązanej",
                                        msg:"Spróbuj ponownie lub skontaktuj się z Biurem Obsługi Klienta.",
                                        part:"3"})
                                }
                            })}
                            else{
                                // modal sukces user porażka parcipient
                            }

                }
    function PeselDecode(pesel, isPar) {
        
        var rok = parseInt(pesel.substring(0, 2), 10);
        var miesiac = parseInt(pesel.substring(2, 4), 10);
        var dzien = parseInt(pesel.substring(4, 6), 10);

        if (miesiac > 80) {
            rok = rok + 1800;
            miesiac = miesiac - 80;
        } else if (miesiac > 60) {
            rok = rok + 2200;
            miesiac = miesiac - 60;
        } else if (miesiac > 40) {
            rok = rok + 2100;
            miesiac = miesiac - 40;
        } else if (miesiac > 20) {
            rok = rok + 2000;
            miesiac = miesiac - 20;
        } else {
            rok += 1900;
        }
        // Daty sa ok. Teraz ustawiamy.
        if(miesiac < 10){
            miesiac = "0" + miesiac 
        }
        if(dzien < 10){
            dzien = "0" + dzien
        }
        var urodzony = rok + '-' + miesiac + '-' + dzien;
   
       
        if(isPar){
            document.getElementById("calendaryParc").value = urodzony
        }else{
            document.getElementById("calendary").value = urodzony
        }
        return urodzony
       
   
    }

    function showCalendary(e){
      
        document.getElementById("calendary").showPicker();
    }

useEffect(()=>{

    let dataUser = {};
    let dataParcipent = {};
    let dataPayer = {};
     if(props.userData.genderDVID != 0){
        dataUser.genderDVID = props.userData.genderDVID
    }
    if(props.userData.pesel != ""){
        dataUser.pesel = props.userData.pesel
    }
    if(props.userData.street != ""){
        dataUser.street = props.userData.street
     }
    if(props.userData.city != ""){
        dataUser.city = props.userData.city
    }
    if(props.userData.postalCode != ""){
        dataUser.postalCode = props.userData.postalCode
    }
     if(props.userData.building != ""){
        dataUser.building = props.userData.building
    }
    if(props.userData.flat != ""){
        dataUser.flat = props.userData.flat
    }
   if(props.userData.dateOfBirdth != "01/01/0001 00:00:00"&&props.userData.dateOfBirdth != null){
        dataUser.dateOfBirdth = props.userData.dateOfBirdth.split(" ")[0]
    }
    if(props.parcipientData != null){
        if(props.parcipientData.genderDVID != 0){
            dataParcipent.genderDVID = props.parcipientData.genderDVID
        }
        if(props.parcipientData.pesel != ""){
            dataParcipent.pesel = props.parcipientData.pesel
        }
        if(props.parcipientData.street != ""){
            dataParcipent.street = props.parcipientData.street
        }
        if(props.parcipientData.city != ""){
            dataParcipent.city = props.parcipientData.city
        }
        if(props.parcipientData.flat != ""){
            dataParcipent.flat = props.parcipientData.flat
        }
         if(props.parcipientData.postalCode != ""){
            dataParcipent.postalCode = props.parcipientData.postalCode
        }
         if(props.parcipientData.building != ""){
            dataParcipent.building = props.parcipientData.building
        }
       if(props.parcipientData.dateOfBirdth != "01/01/0001 00:00:00"&&props.parcipientData.dateOfBirdth != null){
            dataParcipent.dateOfBirdth = props.parcipientData.dateOfBirdth.split(" ")[0]
        }
    }
    if(adultPersonForUser != null){
        if(adultPersonForUser.genderDVID != 0){
            dataPayer.genderDVID = adultPersonForUser.genderDVID
        }
        if(adultPersonForUser.pesel != ""){
            dataPayer.pesel = adultPersonForUser.pesel
        }
        if(adultPersonForUser.street != ""){
            dataPayer.street = adultPersonForUser.street
        }
        if(adultPersonForUser.city != ""){
            dataPayer.city = adultPersonForUser.city
        }
        if(adultPersonForUser.flat != ""){
            dataPayer.flat = adultPersonForUser.flat
        }
         if(adultPersonForUser.postalCode != ""){
            dataPayer.postalCode = adultPersonForUser.postalCode
        }
         if(adultPersonForUser.building != ""){
            dataPayer.building = adultPersonForUser.building
        }
       if(adultPersonForUser.dateOfBirdth != "01/01/0001 00:00:00"&&adultPersonForUser.dateOfBirdth != null){
        dataPayer.dateOfBirdth = adultPersonForUser.dateOfBirdth.split(" ")[0]
        }
    }
   
    setFormData({...formData, ...dataUser})
    setFormDataParcipent({...formDataParcipent, ...dataParcipent})
    setFormDataPayer({...formDataPayer, ...dataPayer})
},[])
function backToBuy(){
    
    userDataCheck.building = formData.building
    userDataCheck.city = formData.city
    userDataCheck.dateOfBirdth = formData.dateOfBirdth
    userDataCheck.flat = formData.flat
    userDataCheck.genderDVID = formData.genderDVID
    userDataCheck.pesel = formData.pesel
    userDataCheck.postalCode = formData.postalCode
    userDataCheck.street = formData.street
    localStorage.setItem('users', JSON.stringify(userDataCheck));
    props.setNavigator()
}
function backToBuyWith(){
    userDataCheck.building = formData.building
    userDataCheck.city = formData.city
    userDataCheck.dateOfBirdth = formData.dateOfBirdth
    userDataCheck.flat = formData.flat
    userDataCheck.genderDVID = formData.genderDVID
    userDataCheck.pesel = formData.pesel
    userDataCheck.postalCode = formData.postalCode
    userDataCheck.street = formData.street
    localStorage.setItem('users', JSON.stringify(userDataCheck));
    if(props.parcipientData){
    parcipientNameDataCheck.building = formDataParcipent.building
    parcipientNameDataCheck.city = formDataParcipent.city
    parcipientNameDataCheck.dateOfBirdth = formDataParcipent.dateOfBirdth
    parcipientNameDataCheck.flat = formDataParcipent.flat
    parcipientNameDataCheck.genderDVID = formDataParcipent.genderDVID
    parcipientNameDataCheck.pesel = formDataParcipent.pesel
    parcipientNameDataCheck.postalCode = formDataParcipent.postalCode
    parcipientNameDataCheck.street = formDataParcipent.street
    localStorage.setItem('selectedPartipient', JSON.stringify(parcipientNameDataCheck));}
    if(adultPersonForUser){
        adultPersonForUser.building = formDataPayer.building
        adultPersonForUser.city = formDataPayer.city
        adultPersonForUser.dateOfBirdth = formDataPayer.dateOfBirdth
        adultPersonForUser.flat = formDataPayer.flat
        adultPersonForUser.genderDVID = formDataPayer.genderDVID
        adultPersonForUser.pesel = formDataPayer.pesel
        adultPersonForUser.postalCode = formDataPayer.postalCode
        adultPersonForUser.street = formDataPayer.street
        localStorage.setItem('selectedPayers', JSON.stringify(adultPersonForUser));}
    
    props.setNavigator()
}
function retry(){
    setStatus({
        tittle:"",
        msg:"",
        part:0})
}

    return <> 
    <div className={modalClass}>
      <Modal close={changeModal}>
      <div className={"fullData_data"}>
                        
                                <div className="chooseConection">
                                <p className="fullData">Wprowadź dane do umowy</p>
      <p className="conent_register">Podanych wcześniej danych nie możesz edytować, jeśli chcesz to zrobić skontaktuj się z naszym Biurem Obsługi Klienta</p>
         
                            <CustomInputValue
                              
                                value={props.userData.firstName}
                                title="Imię"
                                isRequied={true}
                                size="big"
                            ></CustomInputValue>
                            <CustomInputValue
                              
                              value={props.userData.lastName}
                              title="Nazwisko"
                              isRequied={true}
                              size="big"
                          ></CustomInputValue>
                            <CustomInputValue
                              
                              value={props.userData.email}
                              title="Adres E-mail"
                              isRequied={true}
                              size="big"
                          ></CustomInputValue>
                           <CustomInputValue
                              
                              value={props.userData.phone}
                              title="Numer telefonu"
                              isRequied={true}
                              size="big"
                          ></CustomInputValue>
                            {props.userData.genderDVID == 3?<CustomInputValue
                            
                            value={"Nie chcę podawać"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.userData.genderDVID == 2?<CustomInputValue
                            
                            value={"Kobieta"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.userData.genderDVID == 1?<CustomInputValue
                            
                            value={"Mężczyzna"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                         {props.userData.pesel != ""?<CustomInputValue
                            
                            value={props.userData.pesel}
                            title="Pesel"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.userData.dateOfBirdth != "01/01/0001 00:00:00"&&props.userData.dateOfBirdth != null?<CustomInputValue
                            
                            value={props.userData.dateOfBirdth.split(" ")[0]}
                            title="Data urodzenia"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                       {props.userData.building != "" || props.userData.street != ""?<div className="row_input">
                        
                         {props.userData.street != ""?<CustomInputValue
                            
                            value={props.userData.street}
                            title="Ulica"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}

                        {props.userData.building != ""?<CustomInputValue
                            
                            value={props.userData.building}
                            title="Nr domu/mieszkania"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}
                        </div>:""}
                        {props.userData.postalCode != "" || props.userData.city != ""?<div className="row_input">
                        
                        {props.userData.postalCode != ""?<CustomInputValue
                           
                           value={props.userData.postalCode}
                           title="Kod pocztowy"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}

                       {props.userData.city != ""?<CustomInputValue
                           
                           value={props.userData.city}
                           title="Miejscowość"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}
                       </div>:""}
                       {props.userData.genderDVID == 0||props.userData.pesel == ""||props.userData.dateOfBirdth == "01/01/0001 00:00:00"||props.userData.street == ""||props.userData.building == ""||props.userData.postalCode == ""||props.userData.city == ""?<p className="conent_register">Uzpełnij dane:</p>:""}
                            </div>
                            <div className="chooseConection">
                                {props.userData.genderDVID == 0?<p>Płeć</p>:""}
                                {props.userData.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formData.genderDVID == 2}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 2 },
                                        });
                                    }}
                                    label="Kobieta"
                                ></ChooseUserOption>:""}
                                {props.userData.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formData.genderDVID == 1}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 1 },
                                        });
                                    }}
                                    label="Mężczyzna"
                                ></ChooseUserOption>:""}
                               {props.userData.genderDVID == 0? <ChooseUserOption
                                    isChekcked={formData.genderDVID == 3}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 3 },
                                        });
                                    }}
                                    label="Nie chcę podawać"
                                ></ChooseUserOption>:""}
                                {!formDataValidation.genderDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                            </div> 
                          <div className="chooseConection"> 
                                 {props.userData.pesel == ""?<CustomInput
                                id="calendary2"
                                    validation={formDataValidation['pesel']}
                                    showCalendary={() => {
                                        if (!formDataValidation['pesel']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ pesel: true },
                                            });
                                        }
                                    }}
                                    isRequied={true}
                                    title="Pesel"
                                    onChangeInput={(e) => {
                                        let value = e.replaceAll(' ', '');
                                      
                                        if (/^\d+$/.test(value) && value.length == 11) {
                                            let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                                            let sum = 0;
                                            let controlNumber = parseInt(value.substring(10, 11));
                                        
                                            for (let i = 0; i < weight.length; i++) {
                                                sum += (parseInt(value.substring(i, i + 1)) * weight[i]);
                                            }
                                            sum = sum % 10;
                                            let isCorrect =  (10 - sum) % 10 === controlNumber;
                                            if(isCorrect)
                                            {let bd = PeselDecode(value)
                                            if (!formDataValidation['pesel']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ pesel: true, dateOfBirdth: true  },
                                                });
                                            }
                                          
                                           
                                            setFormData({
                                                ...formData,
                                                ...{ pesel: parseInt(value), dateOfBirdth: bd  },
                                            });}else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ pesel: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ pesel: "", dateOfBirdth: "" },
                                                });
                                            }
                                        } else {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ pesel: false },
                                            });
                                            setFormData({
                                                ...formData,
                                                ...{ pesel: "", dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                ></CustomInput>:""}
                               { props.userData.dateOfBirdth == "01/01/0001 00:00:00"||props.userData.dateOfBirdth == null?<CustomInput
                                    id="calendary"
                                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                    validation={formDataValidation['dateOfBirdth']}
                                    showCalendary={(e) => {
                                        e.target.showPicker();
                                        if (!formDataValidation['dateOfBirdth']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                    }}
                                    pattern="dd.mm.rrrr"
                                    type="date"
                                    isRequied={true}
                                    onChangeInput={(e) => {
                                       
                                        let value = e.trim();
                                        if (!formDataValidation['dateOfBirdth']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                            setFormData({
                                                ...formData,
                                                ...{ dateOfBirdth: value },
                                            });
                                        } else {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateOfBirdth: false },
                                            });
                                            setFormData({
                                                ...formData,
                                                ...{ dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                    title="Data urodzenia"
                                ></CustomInput>:""}
                                {props.userData.street == "" || props.userData.building == ""?<div className="row_input">
                                   { props.userData.street == ""?<CustomInput
                                        validation={formDataValidation['street']}
                                        showCalendary={() => {
                                            if (!formDataValidation['street']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ street: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Ulica"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidation['street']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ street: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ street: value },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ street: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ street: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                    {props.userData.building == ""?<CustomInput
                                        validation={formDataValidation['building']}
                                        showCalendary={() => {
                                            if (!formDataValidation['building']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ building: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        pattern="/"
                                        isRequied={true}
                                        title="Nr domu/mieszkania"
                                        onChangeInput={(e) => {
                                            let building = e.split('/')[0];
                                            let flat =
                                                e.split('/')[1] == undefined ? '' : e.split('/')[1];

                                            let value = building;
                                            if (value.length != 0) {
                                                if (!formDataValidation['building']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ building: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ building: parseInt(value), flat: flat },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ building: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ building:"", flat: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>:""}
                                {props.userData.postalCode == "" || props.userData.city == ""?<div className="row_input">
                                    {props.userData.postalCode == ""?<CustomInput
                                        validation={formDataValidation['postalCode']}
                                        showCalendary={() => {
                                            if (!formDataValidation['postalCode']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ postalCode: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Kod pocztowy"
                                        onChangeInput={(e) => {
                                            ///^[0-9]{2}-[0-9]{3}/.test(value)
                                            setFormData({
                                                ...formData,
                                                ...{ postalCode: e },
                                            });
                                            let value = e.trim();
                                            if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                                                if (!formDataValidation['postalCode']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ postalCode: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ postalCode: value },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ postalCode: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ postalCode: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                    {props.userData.city == ""?<CustomInput
                                        validation={formDataValidation['city']}
                                        showCalendary={() => {
                                            if (!formDataValidation['city']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ city: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Miejscowość"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidation['city']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ city: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ city: value },
                                                }); 
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ city: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ city: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>:""}
                                
                              
                            </div> 
                         
                                </div>
                                <CustomButtons clickFunction={(e)=>updateData(e)} classButton="solid" size="big">
                                ZATWIERDŹ
                            </CustomButtons>
      </Modal>
    </div>
    <div className={modalClassII}>
      <Modal close={changeModalII}>
      {props.parcipientData != null?<div className={"fullData_data"}>
      
      <CustomInputValue
                              
                              value={props.parcipientData.firstName}
                              title="Imię"
                              isRequied={true}
                              size="big"
                          ></CustomInputValue>
                          <CustomInputValue
                            
                            value={props.parcipientData.lastName}
                            title="Nazwisko"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                          <CustomInputValue
                            
                            value={props.parcipientData.email}
                            title="Adres E-mail"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                         <CustomInputValue
                            
                            value={props.parcipientData.phone}
                            title="Numer telefonu"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                       
                         {props.parcipientData.genderDVID == 3?<CustomInputValue
                            
                            value={"Nie chcę podawać"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.parcipientData.genderDVID == 2?<CustomInputValue
                            
                            value={"Kobieta"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.parcipientData.genderDVID == 1?<CustomInputValue
                            
                            value={"Mężczyzna"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                         {props.parcipientData.pesel != ""?<CustomInputValue
                            
                            value={props.parcipientData.pesel}
                            title="Pesel"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {props.parcipientData.dateOfBirdth != ""&&props.parcipientData.dateOfBirdth != null?<CustomInputValue
                            
                            value={props.parcipientData.dateOfBirdth.split(" ")[0]}
                            title="Data urodzenia"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                       {props.parcipientData.building != "" || props.parcipientData.street != ""?<div className="row_input">
                        
                         {props.parcipientData.street != ""?<CustomInputValue
                            
                            value={props.parcipientData.street}
                            title="Ulica"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}

                        {props.parcipientData.building != ""?<CustomInputValue
                            
                            value={props.parcipientData.building}
                            title="Nr domu/mieszkania"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}
                        </div>:""}
                        {props.parcipientData.postalCode != "" || props.parcipientData.city != ""?<div className="row_input">
                        
                        {props.parcipientData.postalCode != ""?<CustomInputValue
                           
                           value={props.parcipientData.postalCode}
                           title="Kod pocztowy"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}

                       {props.parcipientData.city != ""?<CustomInputValue
                           
                           value={props.parcipientData.city}
                           title="Miejscowość"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}
                       </div>:""}
                       {props.parcipientData.genderDVID == 0||props.parcipientData.pesel == ""||props.parcipientData.dateOfBirdth == "01/01/0001 00:00:00"||props.parcipientData.street == ""||props.parcipientData.building == ""||props.parcipientData.postalCode == ""||props.parcipientData.city == ""?<p className="conent_register">Brakujące dane osoby powiązanej to:</p>:""}
                        <div className="chooseConection">
                               {props.parcipientData.genderDVID == 0? <p>Płeć</p>:""}
                                {props.parcipientData.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataParcipent.genderDVID == 2}
                                    onCheck={(e) => {
                                        formDataValidationParcipent.genderDVID = true
                                        setFormDataParcipent({
                                            ...formDataParcipent,
                                            ...{ genderDVID: 2 },
                                        });
                                    }}
                                    label="Kobieta"
                                ></ChooseUserOption>:""}
                                {props.parcipientData.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataParcipent.genderDVID == 1}
                                    onCheck={(e) => {
                                        formDataValidationParcipent.genderDVID = true
                                        setFormDataParcipent({
                                            ...formDataParcipent,
                                            ...{ genderDVID: 1 },
                                        });
                                    }}
                                    label="Mężczyzna"
                                ></ChooseUserOption>:""}
                                {props.parcipientData.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataParcipent.genderDVID == 3}
                                    onCheck={(e) => {
                                        formDataValidationParcipent.genderDVID = true
                                        setFormDataParcipent({
                                            ...formDataParcipent,
                                            ...{ genderDVID: 3 },
                                        });
                                    }}
                                    label="Nie chcę podawać"
                                ></ChooseUserOption>:""}
                                {!formDataValidationParcipent.genderDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                            </div> 
                          <div className="chooseConection"> 
                                 {props.parcipientData.pesel == ""?<CustomInput
                                id="calendary2"
                                    validation={formDataValidationParcipent['pesel']}
                                    showCalendary={() => {
                                        if (!formDataValidation['pesel']) {
                                            setFormDataValidationParcipent({
                                                ...formDataValidationParcipent,
                                                ...{ pesel: true },
                                            });
                                        }
                                    }}
                                    isRequied={true}
                                    title="Pesel"
                                    onChangeInput={(e) => {
                                        let value = e.replaceAll(' ', '');
                                      
                                        if (/^\d+$/.test(value) && value.length == 11) {
                                            let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                                            let sum = 0;
                                            let controlNumber = parseInt(value.substring(10, 11));
                                        
                                            for (let i = 0; i < weight.length; i++) {
                                                sum += (parseInt(value.substring(i, i + 1)) * weight[i]);
                                            }
                                            sum = sum % 10;
                                            let isCorrect =  (10 - sum) % 10 === controlNumber;
                                            if(isCorrect)
                                            {let bd = PeselDecode(value,true)
                                            if (!formDataValidationParcipent['pesel']) {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ pesel: true, dateOfBirdth: true  },
                                                });
                                            }
                                          
                                           
                                            setFormDataParcipent({
                                                ...formDataParcipent,
                                                ...{ pesel: parseInt(value), dateOfBirdth: bd  },
                                            });}else {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ pesel: false },
                                                });
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ pesel: "", dateOfBirdth: "" },
                                                });
                                            }
                                        } else {
                                            setFormDataValidationParcipent({
                                                ...formDataValidationParcipent,
                                                ...{ pesel: false },
                                            });
                                            setFormDataParcipent({
                                                ...formDataParcipent,
                                                ...{ pesel: "", dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                ></CustomInput>:""}
                                
                                {props.parcipientData.dateOfBirdth == "01/01/0001 00:00:00"||props.parcipientData.dateOfBirdth == null?<CustomInput
                                    id="calendaryParc"
                                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                    validation={formDataValidationParcipent['dateOfBirdth']}
                                    showCalendary={(e) => {
                                        e.target.showPicker();
                                        if (!formDataValidationParcipent['dateOfBirdth']) {
                                            setFormDataValidationParcipent({
                                                ...formDataValidationParcipent,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                    }}
                                    pattern="dd.mm.rrrr"
                                    type="date"
                                    isRequied={true}
                                    onChangeInput={(e) => {
                                       
                                        let value = e.trim();
                                        if (!formDataValidationParcipent['dateOfBirdth']) {
                                            setFormDataValidationParcipent({
                                                ...formDataValidationParcipent,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                            setFormDataParcipent({
                                                ...formDataParcipent,
                                                ...{ dateOfBirdth: value },
                                            });
                                        } else {
                                            setFormDataValidationParcipent({
                                                ...formDataValidationParcipent,
                                                ...{ dateOfBirdth: false },
                                            });
                                            setFormDataParcipent({
                                                ...formDataParcipent,
                                                ...{ dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                    title="Data urodzenia"
                                ></CustomInput>:""}
                                <div className="row_input">
                                   {props.parcipientData.street == ""? <CustomInput
                                        validation={formDataValidationParcipent['street']}
                                        showCalendary={() => {
                                            if (!formDataValidationParcipent['street']) {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ street: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Ulica"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidationParcipent['street']) {
                                                    setFormDataValidationParcipent({
                                                        ...formDataValidationParcipent,
                                                        ...{ street: true },
                                                    });
                                                }
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ street: value },
                                                });
                                            } else {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ street: false },
                                                });
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ street: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                    {props.parcipientData.building == ""?<CustomInput
                                        validation={formDataValidationParcipent['building']}
                                        showCalendary={() => {
                                            if (!formDataValidationParcipent['building']) {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ building: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        pattern="/"
                                        isRequied={true}
                                        title="Nr domu/mieszkania"
                                        onChangeInput={(e) => {
                                            let building = e.split('/')[0];
                                            let flat =
                                                e.split('/')[1] == undefined ? '' : e.split('/')[1];

                                            let value = building;
                                            if (value.length != 0) {
                                                if (!formDataValidationParcipent['building']) {
                                                    setFormDataValidationParcipent({
                                                        ...formDataValidationParcipent,
                                                        ...{ building: true },
                                                    });
                                                }
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ building: parseInt(value), flat: flat },
                                                });
                                            } else {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ building: false },
                                                });
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ building:"", flat: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>
                                <div className="row_input">
                                {props.parcipientData.postalCode == ""?<CustomInput
                                        validation={formDataValidationParcipent['postalCode']}
                                        showCalendary={() => {
                                            if (!formDataValidationParcipent['postalCode']) {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ postalCode: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Kod pocztowy"
                                        onChangeInput={(e) => {
                                            ///^[0-9]{2}-[0-9]{3}/.test(value)
                                            setFormDataParcipent({
                                                ...formDataParcipent,
                                                ...{ postalCode: e },
                                            });
                                            let value = e.trim();
                                            if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                                                if (!formDataValidationParcipent['postalCode']) {
                                                    setFormDataValidationParcipent({
                                                        ...formDataValidationParcipent,
                                                        ...{ postalCode: true },
                                                    });
                                                }
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ postalCode: value },
                                                });
                                            } else {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ postalCode: false },
                                                });
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ postalCode: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                   {props.parcipientData.city == ""? <CustomInput
                                        validation={formDataValidationParcipent['city']}
                                        showCalendary={() => {
                                            if (!formDataValidationParcipent['city']) {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ city: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Miejscowość"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidationParcipent['city']) {
                                                    setFormDataValidationParcipent({
                                                        ...formDataValidationParcipent,
                                                        ...{ city: true },
                                                    });
                                                }
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ city: value },
                                                }); 
                                            } else {
                                                setFormDataValidationParcipent({
                                                    ...formDataValidationParcipent,
                                                    ...{ city: false },
                                                });
                                                setFormDataParcipent({
                                                    ...formDataParcipent,
                                                    ...{ city: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>
                                
                              
                            </div> 
                            
      </div>:""}
      <CustomButtons clickFunction={(e)=>updateParcipentData(e)} classButton="solid" size="big">
                                ZATWIERDŹ
                            </CustomButtons>
      </Modal>
    </div>
     {/* Kabaret Początek */}
    <div className={modalClassIII}>
      <Modal close={changeModalIII}>
      {adultPersonForUser != null?<div className={"fullData_data"}>
      
      <CustomInputValue
                              
                              value={adultPersonForUser.firstName}
                              title="Imię"
                              isRequied={true}
                              size="big"
                          ></CustomInputValue>
                          <CustomInputValue
                            
                            value={adultPersonForUser.lastName}
                            title="Nazwisko"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                          <CustomInputValue
                            
                            value={adultPersonForUser.email}
                            title="Adres E-mail"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                         <CustomInputValue
                            
                            value={adultPersonForUser.phone}
                            title="Numer telefonu"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>
                       
                         {adultPersonForUser.genderDVID == 3?<CustomInputValue
                            
                            value={"Nie chcę podawać"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {adultPersonForUser.genderDVID == 2?<CustomInputValue
                            
                            value={"Kobieta"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {adultPersonForUser.genderDVID == 1?<CustomInputValue
                            
                            value={"Mężczyzna"}
                            title="Płeć"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                         {adultPersonForUser.pesel != ""?<CustomInputValue
                            
                            value={adultPersonForUser.pesel}
                            title="Pesel"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                          {adultPersonForUser.dateOfBirdth != ""&&adultPersonForUser.dateOfBirdth != null?<CustomInputValue
                            
                            value={adultPersonForUser.dateOfBirdth.split(" ")[0]}
                            title="Data urodzenia"
                            isRequied={true}
                            size="big"
                        ></CustomInputValue>:""}
                       {adultPersonForUser.building != "" || adultPersonForUser.street != ""?<div className="row_input">
                        
                         {adultPersonForUser.street != ""?<CustomInputValue
                            
                            value={adultPersonForUser.street}
                            title="Ulica"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}

                        {adultPersonForUser.building != ""?<CustomInputValue
                            
                            value={adultPersonForUser.building}
                            title="Nr domu/mieszkania"
                            isRequied={true}
                            size="small"
                        ></CustomInputValue>:""}
                        </div>:""}
                        {adultPersonForUser.postalCode != "" || adultPersonForUser.city != ""?<div className="row_input">
                        
                        {adultPersonForUser.postalCode != ""?<CustomInputValue
                           
                           value={adultPersonForUser.postalCode}
                           title="Kod pocztowy"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}

                       {adultPersonForUser.city != ""?<CustomInputValue
                           
                           value={adultPersonForUser.city}
                           title="Miejscowość"
                           isRequied={true}
                           size="small"
                       ></CustomInputValue>:""}
                       </div>:""}
                       {adultPersonForUser.genderDVID == 0||adultPersonForUser.pesel == ""||adultPersonForUser.dateOfBirdth == "01/01/0001 00:00:00"||adultPersonForUser.street == ""||adultPersonForUser.building == ""||adultPersonForUser.postalCode == ""||adultPersonForUser.city == ""?<p className="conent_register">Brakujące dane osoby powiązanej to:</p>:""}
                        <div className="chooseConection">
                               {adultPersonForUser.genderDVID == 0? <p>Płeć</p>:""}
                                {adultPersonForUser.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataParcipent.genderDVID == 2}
                                    onCheck={(e) => {
                                        formDataValidationParcipent.genderDVID = true
                                        setFormDataPayer({
                                            ...formDataPayer,
                                            ...{ genderDVID: 2 },
                                        });
                                    }}
                                    label="Kobieta"
                                ></ChooseUserOption>:""}
                                {adultPersonForUser.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataPayer.genderDVID == 1}
                                    onCheck={(e) => {
                                        formDataValidationPayer.genderDVID = true
                                        setFormDataPayer({
                                            ...formDataPayer,
                                            ...{ genderDVID: 1 },
                                        });
                                    }}
                                    label="Mężczyzna"
                                ></ChooseUserOption>:""}
                                {adultPersonForUser.genderDVID == 0?<ChooseUserOption
                                    isChekcked={formDataPayer.genderDVID == 3}
                                    onCheck={(e) => {
                                        formDataValidationPayer.genderDVID = true
                                        setFormDataPayer({
                                            ...formDataPayer,
                                            ...{ genderDVID: 3 },
                                        });
                                    }}
                                    label="Nie chcę podawać"
                                ></ChooseUserOption>:""}
                                {!formDataValidationPayer.genderDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                            </div> 
                          <div className="chooseConection"> 
                                 {adultPersonForUser.pesel == ""?<CustomInput
                                id="calendary2"
                                    validation={formDataValidationPayer['pesel']}
                                    showCalendary={() => {
                                        if (!formDataValidation['pesel']) {
                                            setFormDataValidationPayer({
                                                ...formDataValidationPayer,
                                                ...{ pesel: true },
                                            });
                                        }
                                    }}
                                    isRequied={true}
                                    title="Pesel"
                                    onChangeInput={(e) => {
                                        let value = e.replaceAll(' ', '');
                                      
                                        if (/^\d+$/.test(value) && value.length == 11) {
                                            let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                                            let sum = 0;
                                            let controlNumber = parseInt(value.substring(10, 11));
                                        
                                            for (let i = 0; i < weight.length; i++) {
                                                sum += (parseInt(value.substring(i, i + 1)) * weight[i]);
                                            }
                                            sum = sum % 10;
                                            let isCorrect =  (10 - sum) % 10 === controlNumber;
                                            if(isCorrect)
                                            {let bd = PeselDecode(value,true)
                                            if (!formDataValidationPayer['pesel']) {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ pesel: true, dateOfBirdth: true  },
                                                });
                                            }
                                          
                                           
                                            setFormDataPayer({
                                                ...formDataPayer,
                                                ...{ pesel: parseInt(value), dateOfBirdth: bd  },
                                            });}else {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ pesel: false },
                                                });
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ pesel: "", dateOfBirdth: "" },
                                                });
                                            }
                                        } else {
                                            setFormDataValidationPayer({
                                                ...formDataValidationPayer,
                                                ...{ pesel: false },
                                            });
                                            setFormDataPayer({
                                                ...formDataPayer,
                                                ...{ pesel: "", dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                ></CustomInput>:""}
                                
                                {adultPersonForUser.dateOfBirdth == "01/01/0001 00:00:00"||adultPersonForUser.dateOfBirdth == null?<CustomInput
                                    id="calendaryParc"
                                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                    validation={formDataValidationPayer['dateOfBirdth']}
                                    showCalendary={(e) => {
                                        e.target.showPicker();
                                        if (!formDataValidationPayer['dateOfBirdth']) {
                                            setFormDataValidationPayer({
                                                ...formDataValidationPayer,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                    }}
                                    pattern="dd.mm.rrrr"
                                    type="date"
                                    isRequied={true}
                                    onChangeInput={(e) => {
                                       
                                        let value = e.trim();
                                        if (!formDataValidationPayer['dateOfBirdth']) {
                                            setFormDataValidationPayer({
                                                ...formDataValidationPayer,
                                                ...{ dateOfBirdth: true },
                                            });
                                        }
                                        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                            setFormDataPayer({
                                                ...formDataPayer,
                                                ...{ dateOfBirdth: value },
                                            });
                                        } else {
                                            setFormDataValidationPayer({
                                                ...formDataValidationPayer,
                                                ...{ dateOfBirdth: false },
                                            });
                                            setFormDataPayer({
                                                ...formDataPayer,
                                                ...{ dateOfBirdth: "" },
                                            });
                                        }
                                    }}
                                    title="Data urodzenia"
                                ></CustomInput>:""}
                                <div className="row_input">
                                   {adultPersonForUser.street == ""? <CustomInput
                                        validation={formDataValidationPayer['street']}
                                        showCalendary={() => {
                                            if (!formDataValidationPayer['street']) {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ street: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Ulica"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidationPayer['street']) {
                                                    setFormDataValidationPayer({
                                                        ...formDataValidationPayer,
                                                        ...{ street: true },
                                                    });
                                                }
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ street: value },
                                                });
                                            } else {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ street: false },
                                                });
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ street: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                    {adultPersonForUser.building == ""?<CustomInput
                                        validation={formDataValidationPayer['building']}
                                        showCalendary={() => {
                                            if (!formDataValidationPayer['building']) {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ building: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        pattern="/"
                                        isRequied={true}
                                        title="Nr domu/mieszkania"
                                        onChangeInput={(e) => {
                                            let building = e.split('/')[0];
                                            let flat =
                                                e.split('/')[1] == undefined ? '' : e.split('/')[1];

                                            let value = building;
                                            if (value.length != 0) {
                                                if (!formDataValidationPayer['building']) {
                                                    setFormDataValidationPayer({
                                                        ...formDataValidationPayer,
                                                        ...{ building: true },
                                                    });
                                                }
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ building: parseInt(value), flat: flat },
                                                });
                                            } else {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ building: false },
                                                });
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ building:"", flat: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>
                                <div className="row_input">
                                {adultPersonForUser.postalCode == ""?<CustomInput
                                        validation={formDataValidationPayer['postalCode']}
                                        showCalendary={() => {
                                            if (!formDataValidationPayer['postalCode']) {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ postalCode: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Kod pocztowy"
                                        onChangeInput={(e) => {
                                            ///^[0-9]{2}-[0-9]{3}/.test(value)
                                            setFormDataPayer({
                                                ...formDataPayer,
                                                ...{ postalCode: e },
                                            });
                                            let value = e.trim();
                                            if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                                                if (!formDataValidationPayer['postalCode']) {
                                                    setFormDataValidationPayer({
                                                        ...formDataValidationPayer,
                                                        ...{ postalCode: true },
                                                    });
                                                }
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ postalCode: value },
                                                });
                                            } else {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ postalCode: false },
                                                });
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ postalCode: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                   {adultPersonForUser.city == ""? <CustomInput
                                        validation={formDataValidationPayer['city']}
                                        showCalendary={() => {
                                            if (!formDataValidationPayer['city']) {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ city: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Miejscowość"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidationPayer['city']) {
                                                    setFormDataValidationPayer({
                                                        ...formDataValidationPayer,
                                                        ...{ city: true },
                                                    });
                                                }
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ city: value },
                                                }); 
                                            } else {
                                                setFormDataValidationPayer({
                                                    ...formDataValidationPayer,
                                                    ...{ city: false },
                                                });
                                                setFormDataPayer({
                                                    ...formDataPayer,
                                                    ...{ city: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>:""}
                                </div>
                                
                              
                            </div> 
                            
      </div>:""}
      <CustomButtons clickFunction={(e)=>updatePayerData(e)} classButton="solid" size="big">
                                ZATWIERDŹ
                            </CustomButtons>
      </Modal>
    </div>
    {/* Kabaret */}
    {status.part == 3 ? (
                        <div className="columnLogin_wrapper">
                            <div className="tittle_wraper">
                                <p className="tittle_register">{status.tittle}</p>
                                <p className="conent_register">{status.msg}</p>
                            </div>
                            {/* <div className={part.tittle != 'Na podane dane został już zarejestrowany użytkownik'?"buttonsWraperReg":"singleButtonWraperReg"}> */}
                            <div className="margin-top-32">
                            <CustomButtons
                                    clickFunction={retry}
                                    classButton="solid"
                                    size="big"
                                >
                                    SPRÓBUJ PONOWNIE
                                </CustomButtons>
                       
                                </div>
                        </div>
                    ) : (
                        ''
                    )}
     {status.part == 2 ? (
                        <div className="columnLogin_wrapper">
                            <div className="tittle_wraper">
                                <p className="tittle_register">{status.tittle}</p>
                                <p className="conent_register">{status.msg}</p>
                            </div>
                            {/* <div className={part.tittle != 'Na podane dane został już zarejestrowany użytkownik'?"buttonsWraperReg":"singleButtonWraperReg"}> */}
                            <div className="margin-top-32">
                           <CustomButtons
                                    clickFunction={backToBuy}
                                    classButton="solid"
                                    size="big"
                                >
                                    WRÓĆ DO PROCESU ZAKUPOWEGO
                                </CustomButtons>
                                </div>
                        </div>
                    ) : (
                        ''
                    )}
      {status.part == 1 ? (
                        <div className="columnLogin_wrapper">
                            <div className="tittle_wraper">
                                <p className="tittle_register">{status.tittle}</p>
                                <p className="conent_register">{status.msg}</p>
                            </div>
                            {/* <div className={part.tittle != 'Na podane dane został już zarejestrowany użytkownik'?"buttonsWraperReg":"singleButtonWraperReg"}> */}
                            <div className="margin-top-32">
                                <CustomButtons
                                    clickFunction={backToBuyWith}
                                    classButton="solid"
                                    size="big"
                                >
                                    WRÓĆ DO PROCESU ZAKUPOWEGO
                                </CustomButtons>
                                </div>
                        </div>
                    ) : (
                        ''
                    )}
    {status.part == 0?<div className="columnLogin_wrapper">
                            <div className="fullData_wraper">
                                <p className="fullData">Wprowadź dane do umowy</p>
                                <p className="conent_register">Gdy wprowadzisz brakujące dane polazostaną zaznaczone i będziesz mógł kontynuować</p>
                                {!adultPersonForUser||!props.parcipientData?<div className={"fullData_data"}><ChooseUserOption
                        isChekcked={formData.genderDVID != 0 &&formData.dateOfBirdth != ""&&formData.pesel!= ""&&formData.street!=""&&formData.building!=""&&formData.city!=""&&formData.postalCode!=""}
                        onCheck={(e) => {
                            
                        }}
                        label={props.userData.firstName +" "+props.userData.lastName}
                    ></ChooseUserOption>
                 
                    <CustomButtons clickFunction={(e)=>changeModal(e)} classButton="outline" size="big">
                                + Twoje dane 
                    </CustomButtons></div>:""}
                      
                               
                                {props.parcipientData?
                                <div className={"fullData_data"}>
                                <ChooseUserOption
                        isChekcked={formDataParcipent.genderDVID != 0 &&formDataParcipent.dateOfBirdth != ""&&formDataParcipent.pesel!= ""&&formDataParcipent.street!=""&&formDataParcipent.building!=""&&formDataParcipent.city!=""&&formDataParcipent.postalCode!=""}
                        onCheck={(e) => {
                            
                        }}
                        label={props.parcipientData.firstName +" "+props.parcipientData.lastName}
                    ></ChooseUserOption>
                 
                    <CustomButtons clickFunction={(e)=>changeModalII(e)} classButton="outline" size="big">
                                + Dane osoby powiązanej 
                    </CustomButtons>
                      

                                </div>:""}
                                {adultPersonForUser?<div className={"fullData_data"}>
                                <ChooseUserOption
                        isChekcked={formDataPayer.genderDVID != 0 &&formDataPayer.dateOfBirdth != ""&&formDataPayer.pesel!= ""&&formDataPayer.street!=""&&formDataPayer.building!=""&&formDataPayer.city!=""&&formDataPayer.postalCode!=""}
                        onCheck={(e) => {
                            
                        }}
                        label={adultPersonForUser.firstName +" "+adultPersonForUser.lastName}
                    ></ChooseUserOption>
                 
                    <CustomButtons clickFunction={(e)=>changeModalIII(e)} classButton="outline" size="big">
                                + Dane opiekuna 
                    </CustomButtons>
                      

                                </div>:""}   
                            </div>
                            {/* :(formData.genderDVID != 0 &&formData.dateOfBirdth != ""&&formData.pesel!= ""&&formData.street!=""&&formData.building!=""&&formData.city!=""&&formData.postalCode!=""?<CustomButtons clickFunction={(e)=>backToBuyWith(e)} classButton="solid" size="big">
                                 WRÓĆ DO PROCESU ZAKUPOWEGO
                            </CustomButtons>: "")*/}
                           
                            {props.parcipientData&&adultPersonForUser?
                            (adultPersonForUser?.genderDVID != 0 &&adultPersonForUser?.dateOfBirdth != ""&&adultPersonForUser?.pesel!= ""&&adultPersonForUser?.street!=""&&adultPersonForUser?.building!=""&&adultPersonForUser?.city!=""&&adultPersonForUser?.postalCode!=""&&props.parcipientData?.genderDVID != 0 &&props.parcipientData?.dateOfBirdth != ""&&props.parcipientData?.pesel!= ""&&props.parcipientData?.street!=""&&props.parcipientData?.building!=""&&props.parcipientData?.city!=""&&props.parcipientData?.postalCode!=""?<CustomButtons clickFunction={(e)=>backToBuyWith(e)} classButton="solid" size="big">
                                WRÓĆ DO PROCESU ZAKUPOWEGO
                            </CustomButtons>: ""):""}
                            {props.userData&&!props.parcipientData||adultPersonForUser&&!props.parcipientData?
                            (formData?.genderDVID != 0 &&formData?.dateOfBirdth != ""&&formData?.pesel!= ""&&formData?.street!=""&&formData?.building!=""&&formData?.city!=""&&formData?.postalCode!=""&&adultPersonForUser?.genderDVID != 0 &&adultPersonForUser?.dateOfBirdth != ""&&adultPersonForUser?.pesel!= ""&&adultPersonForUser?.street!=""&&adultPersonForUser?.building!=""&&adultPersonForUser?.city!=""&&adultPersonForUser?.postalCode!=""?<CustomButtons clickFunction={(e)=>backToBuyWith(e)} classButton="solid" size="big">
                                WRÓĆ DO PROCESU ZAKUPOWEGO
                            </CustomButtons>: ""):""}
                            {props.parcipientData||props.userData&&!adultPersonForUser?
                             (formData?.genderDVID != 0 &&formData?.dateOfBirdth != ""&&formData?.pesel!= ""&&formData?.street!=""&&formData?.building!=""&&formData?.city!=""&&formData?.postalCode!=""&&formDataParcipent?.genderDVID != 0 &&formDataParcipent?.dateOfBirdth != ""&&formDataParcipent?.pesel!= ""&&formDataParcipent?.street!=""&&formDataParcipent?.building!=""&&formDataParcipent?.city!=""&&formDataParcipent?.postalCode!=""?<CustomButtons clickFunction={(e)=>backToBuyWith(e)} classButton="solid" size="big">
                             WRÓĆ DO PROCESU ZAKUPOWEGO
                         </CustomButtons>: ""):""}
                            </div>:""}
                            
    </>;
    }

export default ComplateData;
